import axios from 'axios'
import apiUrl from '../../api.config';

const EXAM_RESULT_API_URL = `${apiUrl}examResult`;

const ExamResultService = {
    studentGetExamResult() {
        return axios.get(EXAM_RESULT_API_URL + '/studentGetExamResult', {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    studentGetPatientResult(patientId = null) {
        const url = patientId 
            ? EXAM_RESULT_API_URL + '/studentGetPatientResult/' + patientId
            : EXAM_RESULT_API_URL + '/studentGetPatientResult';
        
        return axios.get(url, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    teacherFindExamResultByTestId(testId) {
        return axios.get(EXAM_RESULT_API_URL + '/teacherFindExamResultByTestId/' + testId, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    teacherGetExamResultDetail(examResultId) {
        return axios.get(EXAM_RESULT_API_URL + '/teacherGetExamResultDetail/' + examResultId, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    updateExamResult(examResultId, data) {
        return axios.put(EXAM_RESULT_API_URL + '/updateExamResult/' + examResultId, data, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    },
    teacherGetPatientResult(patientId) {
        return axios.get(EXAM_RESULT_API_URL + '/teacherGetPatientResult/' + patientId, {
            headers: {
                'x-access-token': `${localStorage.getItem('accessToken')}`
            }
        })
    }
}

export default ExamResultService;